import React from 'react'
import {numberFormat} from '../../utils/Functions'
import {includes} from 'lodash'

interface IAccountOrderSummary {
  productPriceInfo: any
  excludeField?: string[]
  vatType?: string
}

const AccountOrderSummary: React.FC<IAccountOrderSummary> = (props) => {
  const { productPriceInfo, vatType, excludeField = [] } = props

  return (
    <div>
      <div className={'d-flex justify-content-end text-end'}>
        <div className={'d-flex flex-column align-items-end'}>
          {productPriceInfo?.depositTotal > 0 && (
            <>
              {vatType && ['included', 'excluded']?.includes(vatType) && (
                <span>({vatType === 'included' ? 'รวมภาษี' : 'แยกภาษี'})</span>
              )}
              <div className={'d-flex justify-content-end'}>
                <span>มูลค่าก่อนหักเงินมัดจำ</span>
                <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                  {numberFormat(productPriceInfo?.beforeDepositTotal)}
                </strong>
                <span>บาท</span>
              </div>
              <div className={'d-flex justify-content-end'}>
                <span>เงินมัดจำรวม</span>
                <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                  {numberFormat(productPriceInfo?.depositTotal)}
                </strong>
                <span>บาท</span>
              </div>
            </>
          )}
          {!includes(excludeField, 'discountTotal') && productPriceInfo?.discountTotal > 0 && (
            <div className={'d-flex justify-content-end'}>
              <span>ส่วนลดรวม</span>
              <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                {numberFormat(productPriceInfo.discountTotal)}
              </strong>
              <span>บาท</span>
            </div>
          )}
          {productPriceInfo?.depositTotal > 0 && (
            <div className={'d-flex justify-content-end mb-3'}>
              <span>มูลค่าหลังหักมัดจำ</span>
              <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                {numberFormat(
                  productPriceInfo?.beforeDepositTotal - productPriceInfo?.depositTotal
                )}
              </strong>
              <span>บาท</span>
            </div>
          )}
          {productPriceInfo?.beforeCorrectPrice >= 0 && (
            <div className={'d-flex justify-content-end'}>
              <span>มูลค่าตามเอกสารเดิม</span>
              <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                {numberFormat(productPriceInfo.beforeCorrectPrice)}
              </strong>
              <span>บาท</span>
            </div>
          )}
          {productPriceInfo?.correctPrice >= 0 && (
            <div className={'d-flex justify-content-end'}>
              <span>มูลค่าที่ถูกต้อง</span>
              <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                {numberFormat(productPriceInfo.correctPrice)}
              </strong>
              <span>บาท</span>
            </div>
          )}
          <div className={'d-flex justify-content-end'}>
            <span>มูลค่าไม่มีหรือยกเว้นภาษี</span>
            <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
              {numberFormat(productPriceInfo.noVatItemPriceTotal)}
            </strong>
            <span>บาท</span>
          </div>
          <div className={'d-flex justify-content-end'}>
            <span>มูลค่าที่คำนวณภาษี 0%</span>
            <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
              {numberFormat(productPriceInfo.zeroVatItemPriceTotal)}
            </strong>
            <span>บาท</span>
          </div>
          <div className={'d-flex justify-content-end'}>
            <span>มูลค่าที่คำนวณภาษี 7%</span>
            <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
              {numberFormat(productPriceInfo.vatItemPriceTotal)}
            </strong>
            <span>บาท</span>
          </div>
          <div className={'d-flex justify-content-end'}>
            <span>ภาษีมูลค่าเพิ่ม 7%</span>
            <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
              {numberFormat(productPriceInfo.vatTotal)}
            </strong>
            <span>บาท</span>
          </div>
        </div>
        <div className={'d-flex flex-column align-items-end ms-5 ps-5'}>
          <div className={'d-flex align-items-end bg-primary py-3 px-5 rounded text-white mb-4'}>
            <span>จำนวนเงินทั้งสิ้น</span>
            <span className={'h1 mb-0 ps-5 pe-3 text-white'} style={{minWidth: 150}}>
              {numberFormat(productPriceInfo.total)}
            </span>
            <span>บาท</span>
          </div>
          {productPriceInfo.total !== 0 && (
            <div>
              <div className={'d-flex justify-content-end'}>
                <span>จำนวนเงินที่ถูกหัก ณ ที่จ่าย</span>
                <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                  {numberFormat(productPriceInfo.whTaxTotal)}
                </strong>
                <span>บาท</span>
              </div>
              <div className={'d-flex justify-content-end'}>
                <span>จำนวนเงินที่จะต้องชำระ</span>
                <strong className={'fs-4 ps-5 pe-3'} style={{minWidth: 150}}>
                  {numberFormat(productPriceInfo.amountDue ?? productPriceInfo.subTotal)}
                </strong>
                <span>บาท</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default AccountOrderSummary
